import { render, staticRenderFns } from "./ProductBanner.vue?vue&type=template&id=df142288&scoped=true"
import script from "./ProductBanner.vue?vue&type=script&lang=js"
export * from "./ProductBanner.vue?vue&type=script&lang=js"
import style0 from "./ProductBanner.vue?vue&type=style&index=0&id=df142288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df142288",
  null
  
)

export default component.exports